/* Studworks motion: scroll reveals + small interaction hooks. Skipped entirely for reduced-motion users. */
/* Shopify's preview bar (only on unpublished-theme preview links) sits over the bottom of the screen on phones.
   Measure it and lift the black bar above it so the icons can be tapped while previewing. Live customers never see it. */
(()=>{
  let watched=null;const ro='ResizeObserver' in window?new ResizeObserver(()=>set()):null;
  const set=()=>{const w=document.getElementById('PBarNextFrameWrapper');if(w&&ro&&watched!==w){watched=w;ro.observe(w);}const h=w&&getComputedStyle(w).display!=='none'?Math.round(w.getBoundingClientRect().height):0;document.documentElement.style.setProperty('--pbar',h+'px');};
  set();new MutationObserver(set).observe(document.body,{childList:true,subtree:false,attributes:true,attributeFilter:['style','class']});
  addEventListener('resize',set);setTimeout(set,1500);setTimeout(set,4000);
})();
(()=>{
  if(matchMedia('(prefers-reduced-motion: reduce)').matches||!('IntersectionObserver' in window))return;

  /* [selector, extra class, stagger seconds] - inner items first, then whole sections that have nothing inside animating */
  const groups=[
    ['.best-head, .pdp-head, .pdp-sheet h2, .trk-steps h2, .crew-head','mo--soft',0],
    ['.best-row, [data-best-track]','mo--soft',0],
    ['.scard','mo--zoom',.07],
    ['.pdp-steps li, .trk-steps li, .pdp-sheet dl>div, .pdp-faq-list details, .footer-top>*, .footer-socials>*','mo--soft',.05],
    ['.pdp-story-media, .banner-media, .alpine-photo-pair>*','mo-img',.1],
    ['.pdp-story-copy>*, .trk-help>*, .pdp-noreviews','mo--soft',.08],
    ['main .card:not(.hero):not(.pdp-main):not(.trk-hero), main .alpine-photo-pair','',0],
    ['.msg-ticker','mo--soft',0]
  ];

  const seen=new WeakSet();
  const io=new IntersectionObserver(entries=>{
    const hits=entries.filter(e=>e.isIntersecting).sort((a,b)=>a.boundingClientRect.top-b.boundingClientRect.top||a.boundingClientRect.left-b.boundingClientRect.left);
    hits.forEach((e,i)=>{
      const el=e.target,step=parseFloat(el.dataset.moStep||0);
      if(step)el.style.setProperty('--mo-d',Math.min(i*step,.42)+'s');
      el.classList.add('mo-in');
      io.unobserve(el);
      /* tidy up once the reveal is done so hover transforms work normally */
      setTimeout(()=>{el.classList.remove('mo','mo--soft','mo--zoom');el.style.removeProperty('--mo-d');},1400);
    });
  },{rootMargin:'0px 0px -8% 0px',threshold:.08});

  const vh=innerHeight;
  const prep=()=>groups.forEach(([sel,extra,step])=>{
    document.querySelectorAll(sel).forEach(el=>{
      if(seen.has(el))return;seen.add(el);
      if(el.closest('dialog,.drawer,.cart-drawer,.header-detail'))return; /* drawers have their own animations */
      if(el.matches('.scard')&&el.closest('.best-row,[data-best-track]'))return; /* sideways scrollers reveal as one row */
      if(el.parentElement&&el.parentElement.closest('.mo:not(.mo-in)'))return; /* parent already animates */
      if(el.querySelector('.mo'))return; /* children already animate */
      const r=el.getBoundingClientRect();
      if(r.top<vh*.92&&r.bottom>0)return; /* already on screen at load: leave it alone */
      el.classList.add('mo');if(extra)el.classList.add(...extra.split(' '));
      if(step)el.dataset.moStep=step;
      io.observe(el);
    });
  });
  prep();
  /* catch content added later (infinite scroll, section re-renders) */
  new MutationObserver(m=>{if(m.some(r=>r.addedNodes.length))requestAnimationFrame(prep);}).observe(document.querySelector('main')||document.body,{childList:true,subtree:true});

  /* Bar panels (menu, search, region): one controller.
     - tapping an icon closes whatever else is open (other panels + cart) instantly, then opens its panel and slides it out
     - tapping the same icon again, or the dark overlay, closes it
     Desktop slides out from under the left bar, phones slide up from under the bottom bar. */
  const ease='cubic-bezier(.2,.7,.2,1)';
  document.addEventListener('click',e=>{
    const t=e.target;
    if(t.matches&&t.matches('.header-detail[open]')){e.preventDefault();t.open=false;return;} /* overlay */
    const s=t.closest&&t.closest('.header-detail>summary');if(!s)return;
    e.preventDefault();
    const d=s.parentElement;
    if(d.open){d.open=false;return;}
    document.querySelectorAll('.header-detail[open]').forEach(o=>{o.open=false;});
    const cart=document.getElementById('CartDrawer');
    if(cart&&cart.open){cart.classList.remove('is-open');cart.close();}
    d.open=true;
    const dr=d.querySelector('.drawer');if(!dr)return;
    const mob=matchMedia('(max-width: 860px)').matches;
    dr.getAnimations().forEach(a=>a.cancel());
    dr.animate(mob?[{transform:'translateY(105%)'},{transform:'none'}]:[{transform:'translateX(-105%)'},{transform:'none'}],{duration:mob?380:420,easing:ease});
  },true);

  /* lets :active press states work on iPhone */
  document.addEventListener('touchstart',()=>{},{passive:true});

  /* Cart count bump whenever the number changes */
  const bump=el=>{el.classList.remove('mo-bump');void el.offsetWidth;el.classList.add('mo-bump');};
  document.querySelectorAll('[data-cart-count]').forEach(el=>{
    let last=el.textContent;
    new MutationObserver(()=>{if(el.textContent!==last){last=el.textContent;bump(el);}}).observe(el,{childList:true,characterData:true,subtree:true});
    el.addEventListener('animationend',()=>el.classList.remove('mo-bump'));
  });
})();
